import {Box} from 'platform/foundation';

import {useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {FileField} from '../../kit/components/fields/FileField';
import {useVehicleFormContext} from '../../kit/hooks/useVehicleFormContext';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function BatteryHealthSubSection() {
  const {control} = useVehicleFormContext();

  const batteryCertificate = useWatch({
    control,
    name: 'batteryCertificate',
  });

  return (
    <VFKit.SubSection
      data-testid="battery-health-section"
      title={i18n.t('entity.vehicle.labels.batteryHealth')}
      useCard
    >
      <VFKit.Group data-testid="battery-health-fields" columns={[1, 2, 4]}>
        <VFKit.SimpleNumericField name="batteryCondition" />
        <VFKit.BatteryConditionMeasuredAtDatePicker />
        <VFKit.SimpleNumericField name="actualBatteryRange" />
        <Box paddingTop={5} flexGrow={1}>
          <VFKit.BatteryCertificateCheckbox />
        </Box>
      </VFKit.Group>
      <FileField
        name="batteryCertificateDocument"
        control={control}
        label={i18n.t('entity.vehicle.labels.uploadBatteryCertificate')}
        accept="application/pdf"
        isDisabled={!batteryCertificate}
        data-testid="battery-certificate-upload"
      />
    </VFKit.SubSection>
  );
}
